module.exports = __webpack_public_path__ + "img/mobile/BetBar/Menu_button@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/Menu_button@2x.png
// module id = 597
// module chunks = 0